// Sezione filtro con header (icona outlined verde + titolo) e body.
// Props:
//   - iconClass: classe Flaticon (es. 'fi fi-rr-calendar')
//   - title: string
//   - children: ReactNode (i pill, dropdown, ecc.)
const FilterSection = ({ iconClass, title, children }) => (
    <div className="flex flex-col gap-2">
        <div className="flex items-center gap-2 text-[#225424]">
            {iconClass && <i className={`${iconClass} text-base leading-none`}></i>}
            <h3 className="text-sm font-bold tracking-wide">{title}</h3>
        </div>
        <div>{children}</div>
    </div>
);

export default FilterSection;
